function MissionFrame() {
  return (
    <svg
      width='100%'
      height='100%'
      preserveAspectRatio="none"
      viewBox="0 0 414 214"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0828 0.0241699H413.5H414V0.52417V212.524V213.024H413.5H0.5H0V212.524V15.3801H0.371473L17 0.0557998V0.0241699H17.0343L17.0605 0L17.0828 0.0241699ZM17.4248 1.02417L1 16.1608V212.024H413V1.02417H17.4248Z"
        fill="#22222F"
      />
    </svg>

  );
}

export default MissionFrame;